<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="#ac8a2e" light max-width="100%" width="400" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Login
              </h1>
            </div>
          </template>
          <v-card-text class="text-center">
            <validation-observer v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(validateForm)">
                <validation-provider v-slot="{ errors }" name="Email o dni" rules="required|max:45">
                  <v-text-field v-model="username" color="#ac8a2e" label="Email o dni..." :error-messages="errors" prepend-icon="mdi-email" :disabled="disabled" />
                </validation-provider>
                <validation-provider v-slot="{ errors }" name="contraseña" rules="required|max:45">
                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    :error-messages="errors"
                    class="mb-8"
                    color="#ac8a2e"
                    label="Contraseña..."
                    hint="At least 8 characters"
                    prepend-icon="mdi-lock-outline"
                    :disabled="disabled"
                    @click:append="show1 = !show1"
                  />
                </validation-provider>
                <div>
                  <v-btn elevation="1" color="#ac8a2e" class="ma-1" type="submit" :disabled="disabled">
                    Ingresar
                  </v-btn>
                </div>
              </v-form>
            </validation-observer>
            <v-btn text small class="mt-4" to="/auth/recoveryPassword">
              Olvido su contraseña?
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesLogin',

    data: () => ({
      show1: false,
      username: null,
      password: '',
      disabled: false,
    }),
    methods: {
      validateForm (scope) {
        this.disabled = true
        this.$store.commit('loaderOn', 1)
        this.login()
      },
      login () {
        this.$store.dispatch('retrieveToken', {
          username: this.username,
          password: this.password,
        })
          .then(response => {
            this.$router.push({ name: 'Tablero principal' })
            this.disabled = false
            this.$store.commit('loaderOff')
          })
          .catch(error => {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            this.disabled = false
            this.$store.commit('loaderOff')
          })
      },
    },
  }
</script>
